import MainTabsObj from "../Pages/HomePage/MainTabsObj";
let keyCounter = 0;
export const KeyGen = (items) => {
  return items.map((item, mainIndex) => {
    keyCounter += 1;
    const navigationName = (item.name || item.Component)?.toLowerCase().trim();
    const name = item.title?.toLowerCase().trim();
    if (item.subTabs) {
      return {
        ...item,
        navigationName,
        name,
        key: keyCounter,
        subTabs: KeyGen(item.subTabs),
      };
    } else {
      return {
        ...item,
        navigationName,
        name,
        key: keyCounter,
      };
    }
  });
};

// let billingItems =   KeyGen(BillingTabsObj())
// let setupItems = KeyGen(Setup())
const mainItems = KeyGen(MainTabsObj());
const GlobalNavigation = mainItems;
export default GlobalNavigation;
